import { useEntityAPI } from '../../../redux/entity-api.hook';
import { serviceClassAPI } from '../redux/service-classes.slice';

export function useServiceClasses() {
  return useEntityAPI(serviceClassAPI);
}
